module.exports = __webpack_public_path__ + "img/artillery-wagon-base-15.6d88f640.png";